import React from 'react'
import PropTypes from 'prop-types'
import { Grid, 
        Typography, 
        CircularProgress, 
        Snackbar } from '@material-ui/core'
import Parse from 'parse'
import { withStyles } from '@material-ui/core/styles'
import Item from './Item'
import BlockUi from 'react-block-ui';
import 'react-block-ui/style.css'
import withWidth from '@material-ui/core/withWidth'
import { compose } from 'recompose'

const styles = theme => ({
    grid: {
        marginTop: 54,
        padding: 16
    },
    progress: {
        marginTop: 200
    }
});




class ItemsContainer extends React.Component {



    constructor() {
        super();
        this.state = {
            closets: [],
            items: [],
            loadingItems: true,
            hasMoreResults: false,
            page: 0,
            rowsPerPage: 10,
            saving: false,
            blocking: false,
            openSnackBar: false,
            snackbarMessage: ''
        }
    }

    generateShippingLabel = async item => {

        var items = this.state.items;
        var index = items.indexOf(item);

        try {

            this.setState({blocking: true})

            let updatedItem = await Parse.Cloud.run("CreateShippingLabelForItem", {
                itemId: item.id,
                label_file_type: "PDF_4x6"
            });

            items.splice(index, 1, updatedItem);

            this.setState({
                items: items,
                blocking: false,
                openSnackBar: true,
                snackbarMessage: "Shipping label has been generated!"                     
            })


        } catch (error) {
            this.setState({blocking: false})            
        }
    }

    handleSnackbarClose = () => {
        this.setState({ openSnackBar: false })
    }


    confirmItemShipped = async item => {

        var items = this.state.items
        var index = items.indexOf(item)

        try {

            this.setState({blocking: true})   

            await Parse.Cloud.run("ConfirmItemDelivered", { itemId: item.id });
            items.splice(index, 1);

            this.setState({
                items: items,
                blocking: false,
                openSnackBar: true,
                snackbarMessage: "Item status has been changed."                
            });

        } catch (err) {

        }
    }

    async componentDidMount() {


        const userId = Parse.User.current().id

        // populate all user closets 
        const closetsQuery = new Parse.Query("Closet")
        closetsQuery.equalTo("ownerId", userId);

        const closets = await closetsQuery.find()
        this.setState({ closets: closets });

        const itemsQuery = new Parse.Query("Item")
        itemsQuery.include("photos")
        itemsQuery.include("closet")
        itemsQuery.include("soldTo.userAddress")
        itemsQuery.include("checkoutInfo")
        itemsQuery.exists("serialNumber")
        itemsQuery.exists("soldTo")
        itemsQuery.containedIn("transactionStatus",
            [
                "CREATE_SHIPPING_LABEL",
                "CONFIRM_ITEM_DELIVERED"
            ]
        );
        itemsQuery.equalTo("selectedDeliveryOption", "SHIPPING")
        // present only items which are not archived
        itemsQuery.equalTo("archived", false)
        itemsQuery.limit(this.state.rowsPerPage)
        itemsQuery.skip(this.state.page * 30)
        itemsQuery.containedIn("closet", closets)

        this.setState({ loadingItems: true })

        const items = await itemsQuery.find()
        this.setState({ items: items, loadingItems: false })
    }


    render() {

        const { items, loadingItems, openSnackBar, snackbarMessage } = this.state
        const { classes, width } = this.props


        return (
            <div>
                <BlockUi tag="div" blocking={this.state.blocking}>
                    {items && items.length > 0 ? (
                        <div>
                            <Grid container spacing={16} className={classes.grid} wrap="wrap">
                                {items.map(currentItem => (
                                    <Grid item lg={3} key={currentItem.id}>
                                        <Item item={currentItem}
                                            onShippingLabelCreate={this.generateShippingLabel}
                                            onConfirmItemShipped={this.confirmItemShipped} />
                                    </Grid>
                                ))}
                            </Grid>


                            {/* <StackGrid columnWidth={this._getColumnPercentWidth(width)} className={classes.grid}>
                            {items.map(currentItem => (
                                <Item key={currentItem.id} item={currentItem} />
                            ))}
                        </StackGrid> */}


                        </div>
                    ) :
                        <Grid container
                            className={classes.grid}
                            alignContent="center"
                            alignItems="center"
                            justify="center">

                            <Grid item>
                                {loadingItems ? <CircularProgress className={classes.progress} size={50} /> : <Typography variant="display2" style={{ marginTop: 100 }}>
                                    No items
                        </Typography>}

                            </Grid>
                        </Grid>

                    }
                    <Snackbar
                        open={openSnackBar}
                        autoHideDuration={5000}
                        onClose={this.handleSnackbarClose}
                        message={<span id="message-id">{snackbarMessage}</span>}
                    />
                </BlockUi>
            </div>

        )
    }
}

ItemsContainer.propTypes = {
    classes: PropTypes.object.isRequired
}

ItemsContainer.propTypes = {
    width: PropTypes.string.isRequired,
};

export default compose(
    withStyles(styles),
    withWidth()
)(ItemsContainer)




// WEBPACK FOOTER //
// ./src/components/ItemsContainer.js